import { render } from "./LaChoralePage.vue?vue&type=template&id=0ee2121f"
import script from "./LaChoralePage.vue?vue&type=script&lang=js"
export * from "./LaChoralePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__